<template>
  <select class="form-control">
    <option value="" disabled selected>Loading...</option>
  </select>
</template>

<script>
export default {
  name: 'LoadingSelect'
}
</script>

